// Define tailwind classses for button styles here
const getButtonStyle = (style) => {
    switch (style) {
    case "primary":
        return "btn-primary";

    case "secondary":
        return "btn-secondary";

    case "tertiary":
        return "btn-tertiary";
    
    case "coverGuide":
        return "btn-cover-guide";

    default:
        return "btn-primary";
    }
};

export default getButtonStyle;
